<div class="order-history-container">
    <div class="order-history-title">Detailed Order History</div>
    @if(tableData?.length) {
    <app-mi-table
        [collectionOfColumns]="filterAvailableColumns"
        [attributeLabels]="attributeLabels"
        [data]="tableData"
        entityName="order"
        [isLoading]="isLoading"
        [totalRecords]="totalRecords"
        [itemsPerPage]="itemsPerPage"
        [filterList]="filterList"
        [filterFields]="filterFieldsArray"
        [isEntity]="isEntity"
        (onPageChange)="onPageChange($event)"
        (itemPerPageChange)="itemPerPageChange($event)"
        (onSortData)="onSortData($event)"
        (onRowSelection)="onRowSelect($event)"
        [headerWidget]="true"
        [isOrderHistory]="true">
    </app-mi-table>
    }@else if(!isLoading) {
        <div class="w-full mt-7">
            <div class="flex flex-column h-27rem surface-200 p-2 justify-content-center align-items-center style-box">
              <div class="m-3">
                <div class="flex justify-content-center align-items-center">
                  <span><i class="{{miIcons.ARCHIVED_SEARCH}} inline-block wh-80"></i></span>
                </div>
                <div class="no-result-div">
                  <p translate>lbl_no_results_to_show</p>
                </div>
              </div>
              <div class="mb-4">
                <p class="my-0 pl-3 text-base" translate>no_records_to_show</p>
              </div>
          </div>
        </div>
    }
</div>